import styles from '@mathflat/common/style'
import { type MouseEventHandler, useEffect, useState } from 'react'

import { _OldButton } from '@/component/atoms/Button/_OldButton'
import modalService from '@/service/modal.service'

import { S } from './TimerModal.style'

const SECONDS = 1000

export type ModalProps = {
  onClick: MouseEventHandler<HTMLButtonElement>
}
const TimerModal = ({ onClick }: ModalProps) => {
  const [limitedTime, setLimitedTime] = useState<number>(SECONDS * 5)

  useEffect(() => {
    const timer = setInterval(() => {
      setLimitedTime((prevTime) => prevTime - SECONDS)
    }, SECONDS)

    if (limitedTime <= 0) {
      clearInterval(timer)
    }
    return () => {
      clearInterval(timer)
    }
  }, [limitedTime])

  return (
    <S.Modal>
      {limitedTime > 0 && <S.PreventClickLayer />}
      <div className="modal-body">
        <p>
          관리자 계정에서 스쿨플랫 정식 가입 계약 내역서에 동의/서명하실 수 있습니다. <br />
          동의/서명을 완료하시면, 관리자 계정의 {"‘내 정보'"}에서 계약 내역서를
          <br />
          다운로드 받으실 수 있습니다.
        </p>
        <strong>고객센터 1670-1930</strong>
      </div>
      <div className="modal-footer">
        <_OldButton
          theme="primary"
          onClick={async (e) => {
            modalService.closeModal()
            await onClick(e)
          }}
          style={{
            minWidth: 174,
            padding: 16,
            backgroundColor: styles.colors.primary,
            color: 'white',
          }}
          disabled={limitedTime > 0}
        >
          {limitedTime > 0 ? <>{limitedTime / SECONDS}초 후 창을 닫을 수 있습니다</> : '닫기'}
        </_OldButton>
      </div>
    </S.Modal>
  )
}

export default TimerModal
